import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { FavoritesPageConfig } from '@front-platform/content-builder';
import { favoritesPageResolveConfig } from '@front-platform/content-builder';
import { Component, OnInit, input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavigationHistoryService } from '@core/services/navigation-history/navigation-history.service';
export interface FavoritesPageRuntimeConfig {
  'body'?: any;
}

export type FavoritesPageConfigInput = Partial<
  Omit<FavoritesPageConfig, keyof FavoritesPageRuntimeConfig> & FavoritesPageRuntimeConfig
>;
export type FavoritesPageResolvedConfig = Omit<
  FavoritesPageConfig,
  keyof FavoritesPageRuntimeConfig
> &
  Partial<FavoritesPageRuntimeConfig>;
export interface FavoritesPageContract extends ConfigComponentContract<
  FavoritesPageConfigInput,
  FavoritesPageResolvedConfig
> {}

@Component({
  selector: 'app-favorites-page',
  templateUrl: './favorites-page.component.html',
  standalone: false,
})
export class FavoritesPageComponent implements OnInit, FavoritesPageContract {
  readonly config = input<FavoritesPageConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<FavoritesPageConfig, FavoritesPageRuntimeConfig>(
    favoritesPageResolveConfig,
    () => ({ config: this.config() }),
  );
  get body(): any {
    return this.resolvedConfig()['body'] as unknown as any;
  }

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly navigationHistoryService: NavigationHistoryService,
  ) {}

  ngOnInit(): void {
    this.navigationHistoryService.pushStateFromActivatedRouteSnapshot(
      'user-favorite-shop-list',
      this.activatedRoute.snapshot,
    );

    // @todo: retrieve user favorite shops
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(FavoritesPageComponent, { 'keyAliases': {} });
